export default __webpack_public_path__ + "static/fintech-d99c7c938b024e118f89b8e02d291649.jpg";